import React, {useState} from "react";

import closeIcon from "src/assets/icons/close.svg";
import denyIcon from "src/assets/icons/XDriend.svg";
import {Avatar} from "src/shared/ui/Avatar";
import {Button} from "src/shared/ui/Button";

import {useStyles} from "./styles";
import {EGameFen, FriendTypeEnum, IFriend, IRatingS, ISearchedUser, IUser, RankType} from "../../../../store/models";
import endpoints from "../../../../core/endpoints";
import defaultAvatar from "src/assets/images/defaultPlaceholder.png";
import useStores from "../../../../hooks/useStores";
import {observer} from "mobx-react";
import {DeleteFriendModal} from "../modals/DeleteModal";
import cn from "classnames";

//Иконки для рангов
import Junior1Icon from 'src/assets/icons/chessmen/profile/Junior_Level_01.svg';
import Junior2Icon from 'src/assets/icons/chessmen/profile/Junior_Level_02.svg';
import Junior3Icon from 'src/assets/icons/chessmen/profile/Junior_Level_03.svg';
import Pawn1Icon from 'src/assets/icons/chessmen/profile/Pawn_Level_01.svg';
import Pawn2Icon from 'src/assets/icons/chessmen/profile/Pawn_Level_02.svg';
import Pawn3Icon from 'src/assets/icons/chessmen/profile/Pawn_Level_03.svg';
import Bishop1Icon from 'src/assets/icons/chessmen/profile/Bishop_Level_01.svg';
import Bishop2Icon from 'src/assets/icons/chessmen/profile/Bishop_Level_02.svg';
import Bishop3Icon from 'src/assets/icons/chessmen/profile/Bishop_Level_03.svg';
import Knight1Icon from 'src/assets/icons/chessmen/profile/Knigh_Level_01.svg';
import Knight2Icon from 'src/assets/icons/chessmen/profile/Knigh_Level_02.svg';
import Knight3Icon from 'src/assets/icons/chessmen/profile/Knigh_Level_03.svg';
import Rook1Icon from 'src/assets/icons/chessmen/profile/Rook_Level_01.svg';
import Rook2Icon from 'src/assets/icons/chessmen/profile/Rook_Level_02.svg';
import Rook3Icon from 'src/assets/icons/chessmen/profile/Rook_Level_03.svg';
import Queen1Icon from 'src/assets/icons/chessmen/profile/Queen_Level_01.svg';
import Queen2Icon from 'src/assets/icons/chessmen/profile/Queen_Level_02.svg';
import Queen3Icon from 'src/assets/icons/chessmen/profile/Queen_Level_03.svg';
import King1Icon from 'src/assets/icons/chessmen/profile/King_Level_01.svg';
import King2Icon from 'src/assets/icons/chessmen/profile/King_Level_02.svg';
import King3Icon from 'src/assets/icons/chessmen/profile/King_Level_03.svg';
import Maverick1Icon from 'src/assets/icons/chessmen/profile/Maverick_Level_01.svg';
import Maverick2Icon from 'src/assets/icons/chessmen/profile/Maverick_Level_02.svg';
import Maverick3Icon from 'src/assets/icons/chessmen/profile/Maverick_Level_03.svg';
import Expert1Icon from 'src/assets/icons/chessmen/profile/Expert_Level_01.svg';
import Expert2Icon from 'src/assets/icons/chessmen/profile/Expert_Level_02.svg';
import Expert3Icon from 'src/assets/icons/chessmen/profile/Expert_Level_03.svg';
import Virtuoso1Icon from 'src/assets/icons/chessmen/profile/Virtuoso_Level_01.svg';
import Virtuoso2Icon from 'src/assets/icons/chessmen/profile/Virtuoso_Level_02.svg';
import Virtuoso3Icon from 'src/assets/icons/chessmen/profile/Virtuoso_Level_03.svg';
import Pro1Icon from 'src/assets/icons/chessmen/profile/Pro_Level_01.svg';
import Pro2Icon from 'src/assets/icons/chessmen/profile/Pro_Level_02.svg';
import Pro3Icon from 'src/assets/icons/chessmen/profile/Pro_Level_03.svg';
import Maestro1Icon from 'src/assets/icons/chessmen/profile/Maestro_Level_01.svg';
import Maestro2Icon from 'src/assets/icons/chessmen/profile/Maestro_Level_02.svg';
import Maestro3Icon from 'src/assets/icons/chessmen/profile/Maestro_Level_03.svg';
import GM1Icon from 'src/assets/icons/chessmen/profile/Grand Master_Level_01.svg';
import GM2Icon from 'src/assets/icons/chessmen/profile/Grand Master_Level_02.svg';
import GM3Icon from 'src/assets/icons/chessmen/profile/Grand Master_Level_03.svg';
import Atlant1Icon from 'src/assets/icons/chessmen/profile/Atlant_Level_01.svg';
import Atlant2Icon from 'src/assets/icons/chessmen/profile/Atlant_Level_02.svg';
import Atlant3Icon from 'src/assets/icons/chessmen/profile/Atlant_Level_03.svg';
import Reptilian1Icon from 'src/assets/icons/chessmen/profile/Reptilian_Level_01.svg';
import Reptilian2Icon from 'src/assets/icons/chessmen/profile/Reptilian_Level_02.svg';
import Reptilian3Icon from 'src/assets/icons/chessmen/profile/Reptilian_Level_03.svg';
import Kairos1Icon from 'src/assets/icons/chessmen/profile/Kairos_Level_01.svg';
import Kairos2Icon from 'src/assets/icons/chessmen/profile/Kairos_Level_02.svg';
import Kairos3Icon from 'src/assets/icons/chessmen/profile/Kairos_Level_03.svg';
import CaissasHand1Icon from 'src/assets/icons/chessmen/profile/Caissas_hand_01.svg';
import CaissasHand2Icon from 'src/assets/icons/chessmen/profile/Caissas_hand_02.svg';
import CaissasHand3Icon from 'src/assets/icons/chessmen/profile/Caissas_hand_03.svg';
//

import { useLocale } from "../../../../providers/LocaleProvider";
import {useMediaQuery} from "@mui/material";
import gameHistoryIcon from "src/assets/icons/Game History.svg";
import FriendHistoryModal from "./FriendModal/FriendHistoryModal";
import checkIcon from "src/assets/icons/CheckFriend.svg";
import LiveIcon from "src/assets/icons/LIVE.svg";
import { UserStarsBorder } from "../../../../components/controls/app-bar/components/animateStar/UserStarsBorder";
import { ETypeFilter } from "../../../../store/lobbyStore";

const SPECIAL_USERS = [
    //"bazarwokzal",
    //"alexandra_chess",
    //"floating_morality",
    //"gucci",
    //"shahmatkanal",
    //"mashates1222test",
    "123test"
];

interface FriendItemProps {
    item: IFriend | ISearchedUser;
    onRemove?: () => void;
    onAdd?: () => void;
    onAccept?: () => void;
    onDelete?: () => void;
    sentRequests: string[];
}

type UserLike = IUser | ISearchedUser | { user: IUser, rating: number };

export const FriendItem: React.FC<FriendItemProps> = observer(({
        item,
        onRemove,
        onAdd,
        onAccept,
        sentRequests,
    }) => {
    const classes = useStyles();
    const { friendsStore, lobbyStore, authStore } = useStores();
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const {
        friends: {
            friendlist: {
                total,
                classic,
                wantsToFriend,
                wantsToFriendMob,
                play,
                offline,
                playing,
                alreadySent,
                accept,
                acceptTitle,
                deny,
                waiting,
                add
            },
        },
    } = useLocale();

    const isFriend = (item: IFriend | ISearchedUser): item is IFriend => {
        return 'type' in item && 'user' in item;
    };
    const isMobile = useMediaQuery("(max-width: 560px)");
    const isTablet = useMediaQuery("(max-width: 1024px)");
    const [isStatsOpen, setIsStatsOpen] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);


    const isPendingRequest = isFriend(item) && (item.type === FriendTypeEnum.incoming);
    const user: UserLike = isFriend(item) ? item.user : item;

    const getUserName = (user: UserLike): string => {
        if ('nickname' in user) return user.nickname;
        if ('name' in user) return user.name;
        return 'Unknown User';
    };

    const getUserAvatar = (user: UserLike): string => {
        if ('avatar' in user && user.avatar) {
            return `${endpoints.avatarPath}/${user.avatar}`;
        }
        return defaultAvatar;
    };

    const getUserId = (item: IFriend | ISearchedUser): string => {
        return isFriend(item) ? item.user._id : item.id;
    };

    const renderRating = (item: IFriend | ISearchedUser) => {
        let rating;

        if (isFriend(item)) {
            rating = item.user.rating;
        } else if ('rating' in item) {
            rating = item.rating;
        }

        if (rating) {
            if (typeof rating === 'object' && 'elo' in rating) {
                return rating.elo;
            }
            if (typeof rating === 'number' && Number.isFinite(rating)) {
                return rating;
            }
        }

        return '0';
    };


    const renderWinsLosses = (item: IFriend) => {
        if (item && item.wins && item.losses) {
            const normalStats = {
                wins: item.wins[EGameFen.FEN_NORMAL] || 0,
                losses: item.losses[EGameFen.FEN_NORMAL] || 0
            };
            const chess960Stats = {
                wins: item.wins[EGameFen.FEN_960] || 0,
                losses: item.losses[EGameFen.FEN_960] || 0
            };
            const totalStats = {
                wins: normalStats.wins + chess960Stats.wins,
                losses: normalStats.losses + chess960Stats.losses
            };
            return (
                <div className={classes.winsLossesWrapper}>
                    <div className={classes.winsLossesBlock}>
                        <span className={classes.winLossLabel}>{total("Total")}:</span>
                        <span className={classes.winLossValue}>
                            <span
                                style={{color: totalStats.wins === 0 ? '#F5F5F5E5' : '#4CAF50'}}>{totalStats.wins}</span>
                            <span style={{color: '#F5F5F5E5'}}> : </span>
                            <span
                                style={{color: totalStats.losses === 0 ? '#F5F5F5E5' : '#FF5252'}}>{totalStats.losses}</span>
                        </span>
                    </div>
                    <div className={classes.winsLossesBlock}>
                        <span className={classes.winLossLabel}>{classic("Classic")}:</span>
                        <span className={classes.winLossValue}>
                            <span
                                style={{color: normalStats.wins === 0 ? '#F5F5F5E5' : '#4CAF50'}}>{normalStats.wins}</span>
                            <span style={{color: '#F5F5F5E5'}}> : </span>
                            <span
                                style={{color: normalStats.losses === 0 ? '#F5F5F5E5' : '#FF5252'}}>{normalStats.losses}</span>
                        </span>
                    </div>
                    <div className={classes.winsLossesBlock}>
                        <div className={classes.winLossLabel}>960:</div>
                        <div className={classes.winLossValue}>
                            <span
                                style={{color: chess960Stats.wins === 0 ? '#F5F5F5E5' : '#4CAF50'}}>{chess960Stats.wins}</span>
                            <span style={{color: '#F5F5F5E5'}}> : </span>
                            <span
                                style={{color: chess960Stats.losses === 0 ? '#F5F5F5E5' : '#FF5252'}}>{chess960Stats.losses}</span>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className={classes.winsLossesWrapper}>
                    <div className={classes.winsLossesBlock}>
                        <div className={classes.winLossLabel}>{total("Total")}:</div>
                        <div className={classes.winLossValue}>
                            <span style={{color: '#F5F5F5E5'}}>0 : 0</span>
                        </div>
                    </div>
                    <div className={classes.winsLossesBlock}>
                        <div className={classes.winLossLabel}>{classic("Classic")}:</div>
                        <div className={classes.winLossValue}>
                            <span style={{color: '#F5F5F5E5'}}>0 : 0</span>
                        </div>
                    </div>
                    <div className={classes.winsLossesBlock}>
                        <div className={classes.winLossLabel}>960:</div>
                        <div className={classes.winLossValue}>
                            <span style={{color: '#F5F5F5E5'}}>0 : 0</span>
                        </div>
                    </div>
                </div>
            );
        }
    };

    const getRank = (item: IFriend | ISearchedUser) => {
        const rankValue = "user" in item ?
            item.user.rankFull?.name :
            (typeof item.rank === 'string' ? item.rank : item.rank?.title);

        if (!rankValue) {
            console.warn("No rank data found for user:", item);
            return <span>No Rank</span>;
        }

        const match = rankValue.match(/^(.*?)(?:\s+(\d+))?$/);
        const rankTitle = match?.[1]?.toLowerCase() || "junior";
        const rankLevel = match?.[2] || "1";

        const sanitizedRankName = `${rankTitle} ${rankLevel}`.toLowerCase();
        const rankIcon = getIconByRank(sanitizedRankName);

        return (
            <img
                src={rankIcon}
                alt={`${rankTitle} ${rankLevel}`}
                className={classes.rankIcon}
            />
        );
    };

    const getIconByRank = (rankName: string) => {
        const sanitizedRankName = rankName.replace(/['\s]+/g, '').toLowerCase();
        const match = sanitizedRankName.match(/^(.*?)(\d+)?$/); 
        const piece = match?.[1] || ''; 
        const level = match?.[2] || '1'; 

        const getIcon = (level1Icon: string, level2Icon: string, level3Icon: string) => {
            if (level === '1') return level1Icon;
            if (level === '2') return level2Icon;
            return level3Icon;
        };

        switch (piece) {
            case 'junior': return getIcon(Junior1Icon, Junior2Icon, Junior3Icon);
            case 'pawn': return getIcon(Pawn1Icon, Pawn2Icon, Pawn3Icon);
            case 'bishop': return getIcon(Bishop1Icon, Bishop2Icon, Bishop3Icon);
            case 'knight': return getIcon(Knight1Icon, Knight2Icon, Knight3Icon);
            case 'castle': return getIcon(Rook1Icon, Rook2Icon, Rook3Icon);
            case 'queen': return getIcon(Queen1Icon, Queen2Icon, Queen3Icon);
            case 'king': return getIcon(King1Icon, King2Icon, King3Icon);
            case 'maverick': return getIcon(Maverick1Icon, Maverick2Icon, Maverick3Icon);
            case 'expert': return getIcon(Expert1Icon, Expert2Icon, Expert3Icon);
            case 'virtuoso': return getIcon(Virtuoso1Icon, Virtuoso2Icon, Virtuoso3Icon);
            case 'pro': return getIcon(Pro1Icon, Pro2Icon, Pro3Icon);
            case 'maestro': return getIcon(Maestro1Icon, Maestro2Icon, Maestro3Icon);
            case 'grandmaster': case 'gm': return getIcon(GM1Icon, GM2Icon, GM3Icon);
            case 'atlant': return getIcon(Atlant1Icon, Atlant2Icon, Atlant3Icon);
            case 'reptilian': return getIcon(Reptilian1Icon, Reptilian2Icon, Reptilian3Icon);
            case 'kairos': return getIcon(Kairos1Icon, Kairos2Icon, Kairos3Icon);
            case 'caissashand': return getIcon(CaissasHand1Icon, CaissasHand2Icon, CaissasHand3Icon);
            default:
                console.warn(`Unknown rank: ${rankName}`);
                return Junior1Icon;
        }
    };

    const isRequestSent = sentRequests.includes(getUserId(item));

    const handleDeleteFriend = async () => {
        if (isFriend(item)) {
            try {
                await friendsStore.deleteFriend({playerTo: item.user._id});
                setShowDeleteModal(false);
            } catch (error) {
                console.error('Error deleting friend:', error);
            }
        }
    };

    const handlePlayClick = () => {
        if (lobbyStore.totalActiveGamesCount >= 4) {
            return;
        }

        const friendId = isFriend(item) ? item.user._id : item.id;
        lobbyStore.setSelectedFriend(friendId);
        lobbyStore.toggleFilter(true, ETypeFilter.creator);
    };

    const handleGameHistoryClick = () => {
        if (isFriend(item)) {
            setShowHistoryModal(true);
        }
    };

    const currentUserNickname = authStore?.currentUser?.nickname?.toLowerCase() || "";
    const friendNickname = getUserName(user).toLowerCase();
    const isSpecialUser = SPECIAL_USERS.includes(friendNickname);
    const starsCount = isFriend(item) ? item.user.stars || 0 : 0;

    return (
        <>
            <div className={classes.itemWrapper}>
                <div className={classes.userInfoWrapper}>
                    <div className={classes.avatarContainer}> 
                        <Avatar
                            src={getUserAvatar(user)}
                            wrapperClassName={classes.avatarWrapper}
                        />
                        <UserStarsBorder
                            starsCount={starsCount}
                            className={classes.starsOverlay} 
                        />
                        {isSpecialUser && (
                            <div className={classes.liveIconWrapper}>
                                <img src={LiveIcon} alt="LIVE" className={classes.liveIcon} />
                            </div>
                        )}
                    </div>
                    <div className={classes.userDetailsWrapper}>
                        <div className={classes.nameRatingWrapper}>
                            <div className={classes.userNameBox}>
                                <span
                                    className={cn(classes.userName, {
                                        [classes.marquee]: isMobile && getUserName(user).length > 10 || !isMobile && getUserName(user).length > 20
                                    })}
                                >
                                    {getUserName(user)}
                                </span>
                            </div>
                            {isPendingRequest ? (
                                <span className={classes.raitingTitle}>
                                    {isMobile ? wantsToFriendMob("Frienemies request") : wantsToFriend("Wants to be your frienem")}
                                </span>
                            ) : (
                                <div className={classes.ratingColumn}>
                                    <div className={classes.statsRow}>
                                        <div className={classes.ratingBlock}>
                                            <span className={classes.userRatingTitle}>RP: </span>
                                            <span
                                                className={classes.userRating}>{Math.round(Number(renderRating(item)))}</span>
                                        </div>
                                        <div className={classes.rankBlock}>
                                            <span className={classes.userRank}>
                                                {getRank(item)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                        {/*{isFriend(item) && !isPendingRequest && (*/}
                        {/*    <div className={classes.winsLossesColumn}>*/}
                        {/*        {renderWinsLosses(item)}*/}
                        {/*    </div>*/}
                        {/*)}*/}
                    </div>
                </div>
                <div className={classes.buttonWrapper}>
                    {isPendingRequest ? (
                        <>
                            {isMobile ? (
                                <Button
                                    text=""
                                    icon={checkIcon}
                                    type="secondary"
                                    onClick={onAccept}
                                    classNameIcon={classes.acceptIcon}
                                    className={classes.mobileBtn}
                                />
                            ) : (
                                <Button
                                    text={acceptTitle("Accept")}
                                    type="secondary"
                                    onClick={onAccept}
                                />
                            )}
                            {isMobile ? (
                                <Button
                                    text=""
                                    icon={denyIcon}
                                    type="secondary"
                                    color="red"
                                    onClick={onRemove}
                                    classNameIcon={classes.denyIcon}
                                    className={classes.mobileBtn}
                                />
                            ) : (
                                <Button
                                    text={deny("Deny")}
                                    type="secondary"
                                    color="red"
                                    onClick={onRemove}
                                />
                            )}
                        </>
                    ) : isFriend(item) ? (
                        <>
                            <Button
                                text={
                                    item.type === FriendTypeEnum.outgoing ? 'requested' :
                                        !item.online ? offline("Offline") :
                                            item.isPlaying ? playing("In Game") :
                                                item.isWaiting ? waiting("Waiting...") :
                                                    play("Play")
                                }
                                type={
                                    item.type === FriendTypeEnum.outgoing || !item.online
                                        ? 'offline'
                                        : item.isPlaying || item.isWaiting
                                            ? 'waiting'
                                            : 'secondary'
                                }
                                onClick={handlePlayClick}
                                disabled={
                                    item.isPlaying ||
                                    item.isWaiting ||
                                    lobbyStore.totalActiveGamesCount >= 4 ||
                                    item.type === FriendTypeEnum.outgoing ||
                                    !item.online
                                }
                                className={cn({
                                    createBtnDisabled: lobbyStore.totalActiveGamesCount >= 4,
                                    'bg-green-500': item.isPlaying || item.isWaiting || item.type === FriendTypeEnum.outgoing,
                                })}
                            />
                            <Button
                                text=""
                                icon={gameHistoryIcon}
                                type="statistic"
                                onClick={handleGameHistoryClick}
                                classNameIcon={classes.historyIcon}
                            />
                            <Button
                                text=""
                                icon={closeIcon}
                                type="close"
                                onClick={() => setShowDeleteModal(true)}
                                classNameIcon={classes.closeIcon}
                            />
                        </>
                    ) : isRequestSent ? (
                        <Button text={alreadySent("Already Sent")} type="grey" disabled />
                    ) : (
                        <Button text={isMobile ? "Add" : add("Add Frienemy")} type="secondary" onClick={onAdd} />
                    )}
                </div>
            </div>
            <DeleteFriendModal
                isOpen={showDeleteModal}
                onOpenChange={setShowDeleteModal}
                onConfirm={handleDeleteFriend}
                friendName={getUserName(user)}
            />
            {isFriend(item) && (
                <FriendHistoryModal
                    isOpen={showHistoryModal}
                    onOpenChange={setShowHistoryModal}
                    friend={item}
                />
            )}
        </>
    );
});

